import { Stack, styled, ListItem, ListItemText, ListItemButton } from '@mui/material';
import { ReactNode } from 'react';

const ROW_HEIGHT = 52;
const LOGO_SIZE = 36;

const StyledListItemButton = styled(ListItemButton)(({ theme: { spacing } }) => ({
	height: ROW_HEIGHT,
	padding: spacing(1),
	gap: spacing(2),
}));

const ImageContainer = styled(Stack, {
	shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor: string }>(({ bgColor, theme: { shape } }) => ({
	justifyContent: 'center',
	alignItems: 'center',
	position: 'relative',
	height: LOGO_SIZE,
	width: LOGO_SIZE,
	borderRadius: shape.borderRadius,
	overflow: 'hidden',

	'&::after': {
		content: '""',
		position: 'absolute',
		inset: 0,
		backgroundColor: bgColor,
		opacity: 0.3,
	},
}));

type SimulatorListItemProps = {
	backgroundColor: string;
	name: string;
	svgIcon: ReactNode;
};

const SimulatorListItem = ({ backgroundColor, name, svgIcon }: SimulatorListItemProps) => (
	<ListItem disablePadding>
		<StyledListItemButton>
			<ImageContainer bgColor={backgroundColor}>{svgIcon}</ImageContainer>

			<ListItemText primary={name} />
		</StyledListItemButton>
	</ListItem>
);

export default SimulatorListItem;
